import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useGetOne } from "react-admin";
import CustomMessage from "../../unit/CustomMessage";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import formatPercentage from "../../unit/formatPercentage";
import useNotify from "../../unit/useNotify";

const TableCellRight = styled(TableCell)({ textAlign: "right" });

const LoanModificationLog = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  //loan/paymentschedule/current/appId
  const { data, error, isLoading, isPending, isFetching } = useGetOne(
    "loan/paymentschedule/modifyPayment",
    { id: appId }
  );
  if (isPending || isFetching) {
    return <Typography sx={{ p: 5 }}>Loading...</Typography>;
  }
  if (error) return <CustomMessage message="Error loading Loan" />;
  if (!data) return <CustomMessage message="No data found for this id" />;
  const modifyLogData = data.modifyData;
  const beforeModifyData = data.beforeModifyData;

  return (
    <>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable
          stickyHeader
          id="table-loan-summary-modification-log-list"
          style={{ tableLayout: "fixed" }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Reset Date
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Reset by
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                New Terms <br />
                Starting <br />
                Date
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Remaining Loan Amount
              </TableCell>
              <TableCell
                align="left"
                className="hm-table-header"
                sx={{ minWidth: "100px", width: "100px", maxWidth: "100px" }}
              >
                Interest <br />
                Rate
              </TableCell>
              <TableCell sx={{ minWidth: "150px" }} className="hm-table-header">
                First Payment
                <br /> Under Modified
                <br /> Terms
              </TableCell>
              <TableCell className="hm-table-header">
                Payment Frequency
              </TableCell>
              <TableCell
                className="hm-table-header"
                sx={{
                  width: "100px",
                  maxWidth: "100px",
                  minWidth: "100px",
                }}
              >
                Remaining
                <br />
                Term <br />
                (Months)
              </TableCell>
              <TableCell
                align="right"
                className="hm-table-header"
                sx={{ minWidth: "100px", width: "100px", maxWidth: "100px" }}
              >
                Payment <br />
                Amount
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Maturity <br />
                Date
              </TableCell>
              <TableCell sx={{ minWidth: "150px" }} className="hm-table-header">
                Reason
              </TableCell>
              <TableCell className="hm-table-header" sx={{ minWidth: "150px" }}>
                Notes
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {beforeModifyData &&
              beforeModifyData.map((item: any) => (
                <TableRow key={item.iId} sx={{ background: "#e8e7e7ff" }}>
                  <TableCell className="dateText">
                    {formatDate(item.created_at)}
                  </TableCell>
                  <TableCell>{item.created_by}</TableCell>
                  <TableCell>{item?.sChangeReason}</TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.iLoanAmount)}
                  </TableCell>
                  <TableCell className="numericText">
                    {formatPercentage(item.iRate / 100)}
                  </TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dNoteDate)}
                  </TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dFirstPaymentDate)}
                  </TableCell>
                  <TableCell>{item.sPaymentFrequency}</TableCell>
                  <TableCell className="numericText">{item.iTerm}</TableCell>
                  <TableCell></TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dMaturityDate)}
                  </TableCell>
                  <TableCell>{item?.sNote}</TableCell>
                </TableRow>
              ))} */}
            {modifyLogData &&
              modifyLogData.map((item: any) => (
                <TableRow key={item.iId}>
                  <TableCell className="dateText">
                    {formatDate(item.created_at)}
                  </TableCell>
                  <TableCell className="dateText">{item.created_by}</TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dNoteDate)}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.iLoanAmount)}
                  </TableCell>
                  <TableCell className="numericText">
                    {formatPercentage(item.iRate / 100)}
                  </TableCell>

                  <TableCell className="dateText">
                    {formatDate(item.dFirstPaymentDate)}
                  </TableCell>
                  <TableCell>{item.sPaymentFrequency}</TableCell>
                  <TableCell className="numericText">{item.iTerm}</TableCell>
                  <TableCell className="amountText">
                    {/* {item.iFixedPaymentAmount &&
                      item.iFixedPaymentAmount > 0 &&
                      formatCurrency(item.iFixedPaymentAmount)} */}
                    {item.iFixedPaymentAmount > 0
                      ? formatCurrency(item.iFixedPaymentAmount)
                      : item?.dFirstPaymentAmount > 0
                      ? formatCurrency(item.dFirstPaymentAmount)
                      : ""}
                  </TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dMaturityDate)}
                  </TableCell>
                  <TableCell>{item?.sChangeReason}</TableCell>
                  <TableCell>{item?.sNote}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default LoanModificationLog;
